  export const tiposCaeCaiAdapter = (rawData) => {
    const { data } = rawData;
    if (data?.length > 0) {
      const rows = data?.map((item) => {
        const {
          ID,
          NOMBRE,
          OBSERVACION,
          SIN_CAE
        } = item;
  
        return {
          id: ID ?? null,
          nombre: NOMBRE ?? null,
          descripcion: OBSERVACION ?? null,
          sinCae: SIN_CAE ? (SIN_CAE === 'S') : false
        };
      });
      return { rows: rows };
    }
  };